"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServerError_1 = __importDefault(require("./ServerError"));
class ValidationServerError extends ServerError_1.default {
    constructor(response, responseData) {
        super('ValidationServerError', response, responseData);
    }
    getViolations() {
        if (this.responseData['violations'] === undefined) {
            return [];
        }
        return this.responseData['violations'];
    }
    toString() {
        let violations = ``;
        this.getViolations().map((violation) => {
            violations += `<div>- <b>${violation.propertyPath}:</b> ${violation.message}</div>`;
        });
        return violations;
    }
}
exports.default = ValidationServerError;
